/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListEquipmentQueryResponse, ListEquipmentPathParams, ListEquipmentQueryParams, ListEquipment400, ListEquipment401, ListEquipment403, ListEquipment404, ListEquipment409, ListEquipment500 } from "../../types/equipmentController/ListEquipment.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListEquipmentUrl(organizationId: ListEquipmentPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/equipment/` as const }
  return res
}

/**
 * @summary List equipment
 * {@link /api/organizations/:organizationId/equipment/}
 */
export async function listEquipment(organizationId: ListEquipmentPathParams["organizationId"], params?: ListEquipmentQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListEquipmentQueryResponse, ResponseErrorConfig<ListEquipment400 | ListEquipment401 | ListEquipment403 | ListEquipment404 | ListEquipment409 | ListEquipment500>, unknown>({ method : "GET", url : getListEquipmentUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}